<script setup lang="ts">
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

const isSearchPopoverOpen = ref(false)
const searchPopoverRef = ref<HTMLElement | null>(null)

onClickOutside(searchPopoverRef, () => {
  isSearchPopoverOpen.value = false
})

function closePopover() {
  isSearchPopoverOpen.value = false
}

defineExpose({
  closePopover
})
</script>

<template>
  <div ref="searchPopoverRef" class="relative">
    <button
      type="button"
      class="flex items-center justify-center gap-2 border border-stroke p-2 text-slate-700 transition hover:bg-slate-50"
      title="Filtros"
      @click="isSearchPopoverOpen = !isSearchPopoverOpen"
    >
      <p class="text-sm font-medium text-slate-700">Filtros</p>
      <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </button>
    <div
      v-show="isSearchPopoverOpen"
      class="absolute right-0 top-full z-50 mt-2 w-72 border border-stroke bg-white p-3 shadow-lg"
    >
      <slot :close="closePopover"></slot>
    </div>
  </div>
</template>
